<template>
  <div>
    <div class="page-content">
      <div class="agree-wrapper" v-show="mxIsContract == 2 || mxIsContract < 0">
        <el-row>
          <el-col :span="24">
            <div class="agree-header"><i class="el-icon-warning"></i></div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <div class="agree-title" v-show="mxIsContract < 0">
              该公司未绑定合同，请上传合同文件
            </div>
            <div class="agree-title" v-show="mxIsContract == 2">
              合同审核拒绝，请重新上传
            </div>
          </el-col>
        </el-row>
      </div>
      <el-row
        class="contact-upload"
        v-show="mxIsContract == 2 || mxIsContract < 0"
      >
        <el-form
          ref="contractForm"
          :model="formData"
          :rules="rules"
          label-width="100px"
        >
          <el-col :span="24" class="content-left">
            <el-form-item label="上传文件" prop="file_url">
              <upload-file
                @remove_file="handleRemoveFile"
                @return_url="handUploadFile"
                :title="title"
                :multiple="'false'"
                :multiSelection="false"
                :dir="'bill'"
                :selectfiles="'importExcel'"
                :postfiles="'submitImportExcel'"
                :ossfile="'ossExcelFile'"
                ref="uploadImg"
                :max_width="1000"
                :max_height="1000"
              />
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div
        class="warn-title"
        v-show="mxIsContract == 0"
        style="margin-top: 120px"
      >
        合同审核中，请稍后再试或联系管理员尽快审核
      </div>
      <!-- <div class="warn-title" v-show="mxIsContract == 2" style="margin-top: 120px">合同审核失败，请联系管理员</div> -->
      <div class="mod-index" v-show="mxIsContract == 1">
        <el-row class="top" style="width: 100%;">
          <el-col :span="2.5">
            <!-- 汇付充值 -->
            <el-button
              v-if="this.isHuifu"
              type="danger"
              @click="huifuRecharge"
              size="mini"
              style="margin-right: 10px;"
              >余额充值</el-button
            >
          </el-col>
          <el-col
            :span="2.5"
            v-if="!this.isAlipay && !ISwssft && userPermissions.indexOf('refund_apply') != -1"
            style="margin-right: 10px;"
          >
            <el-button type="primary" size="mini" @click="initRefund"
              >发起退款</el-button
            >
          </el-col>
          <!-- <el-col :span="2.5" v-if="!this.isAlipay" style="margin-right: 10px;"
            ><LookRefund ref="initiateRefund"
          /></el-col> -->
          <el-col :span="2.5" style="margin-right: 10px;"
			v-if="userPermissions.indexOf('refund_list') != -1"
            ><LookRefund ref="initiateRefund" :isAlipay="this.isAlipay"
          /></el-col>
          <el-col :span="2.5" v-if="!this.isAlipay && userPermissions.indexOf('record_list') != -1"><LookLiushui /></el-col>

          <el-col
            :span="this.isAlipay ? 24 : 20"
            :style="{ marginLeft: this.isAlipay ? '0' : '26px' }"
          >
            <el-form size="medium" :inline="true" style="text-align: right">
              <el-form-item
                ><HomeDatePicker @dataSearch="dataSearch"
              /></el-form-item>
              <el-button
                type="primary"
                @click="alipayRecharge"
                size="mini"
                style="height: 32px"
                v-if="this.isAlipay"
                >授权</el-button
              >
              <el-button
                type="warning"
                @click="alipayThaw"
                size="mini"
                style="height: 32px"
                v-if="this.isAlipay"
                >解冻</el-button
              >
            </el-form>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="display: flex;flex-wrap: wrap;">
          <el-col
            :style="{width:item.width|| '250px'}"
            :span="4"
            v-for="(item, index) in this.list"
            :key="index"
          >
            <div class="grid-content bg-purple">
              <div class="info">
                <div class="info-title">{{ item.title }}</div>
                <div class="info-price">{{ item.value }}</div>
              </div>
              <img :src="item.imgUrl" class="info-img" />
            </div>
          </el-col>
        </el-row>
        <el-row class="recharge-wrapper">
          <el-col :span="8"><div class="recharge">充值计算器</div></el-col>

          <el-col :span="16" class="calculation">
            <countImportTaxBasis @remove_file="handleRemoveFile"
              @return_url="handTaxUploadFile"
              :dir="'task'"
              ref="uploadImg"
              :title="title"
              :max_width="1000"
              :max_height="1000"></countImportTaxBasis>
            <el-input
              v-if="Number(this.rateType) == 1"
              @input="changeInputPrice"
              placeholder="请输入结算金额"
              class="calculation-price"
              v-model="inputPrice"
            ></el-input>
            <el-input
              v-else
              @input="changeInputPrice"
              placeholder="充值金额"
              class="calculation-price"
              v-model="inputPrice"
            ></el-input>
            <div
              class="calculate"
              @click="calculationPrice"
              onclick="MtaH5.clickStat('calcrechargemoney')"
            >
              计算
            </div>
          </el-col>
        </el-row>
        <div class="price-wrapper">
          <div class="price-left">
            <div class="price-item-wrapper">
              <div v-if="Number(this.rateType) == 1" class="first-price-item">
                需充值金额：
                <div class="first-price-span">{{ this.rechargePrice }}</div>
              </div>
              <div v-else class="first-price-item">
                可下发金额：
                <div class="first-price-span">{{ this.rechargePrice }}</div>
              </div>
              <div class="price-item">
                服务费：
                <span class="price-span">{{ this.servicePrice }}</span>
                元
              </div>
              <div v-if="preTaxAmount" class="price-item">
                税前金额：
                <span class="price-span">{{ this.preTaxAmount }}</span>
                元
              </div>
            </div>
          </div>
          <div class="price-right">
			<div class="price-right-wrap" v-if="!this.ISAuxiliary">
				<div class="price-item-wrapper" v-if="this.taxrate !== 0">
					<div class="first-price-item" v-if="!is_hidden_rate">
					服务费率：
					<div class="first-price-span">{{ this.taxrate }}%</div>
					</div>
					<!--              <div class="first-price-item">服务费类型：<div class="first-price-span">{{ this.rateType==='1'?'外加':'内扣' }}</div></div>-->
					<div class="price-item" :class="{pd:is_hidden_rate}">
					打款户名：
					<span class="price-span">{{ this.accountName }}</span>
					</div>
					<div
					class="price-item"
					v-if="this.paymentAccount !== '' && !ISLingxin && !isAlipay"
					>
					打款账户：
					<span class="price-span">{{ this.paymentAccount }}</span>
					</div>
					<div class="price-item" v-if="!ISLingxin">
					开户行：
					<span class="price-span">{{ this.bankOfDeposit }}</span>
					</div>
				</div>
				<div v-else class="zeroRate">
					<div class="price-item">
					打款户名：
					<span class="price-span">{{ this.accountName }}</span>
					</div>
					<div
					class="price-item"
					v-if="this.paymentAccount !== '' && !ISLingxin && !isAlipay"
					>
					打款账户：
					<!-- <span class="price-span">{{ this.paymentAccount }}</span> -->
           <!-- 测试环境 根据要求隐藏打款账户 -->
					<span class="price-span"> * * * * * * * * * * </span>

					</div>
					<div class="price-item" v-if="!ISLingxin">
					开户行：
					<span class="price-span">{{ this.bankOfDeposit }}</span>
					</div>
				</div>
			</div>
          </div>
        </div>
      </div>
    </div>
    <NoticeDialog
      :dialogVisible="dialogVisible"
      :htmlData="htmlData"
      @know="know"
      @handleClose="handleClose"
    />
    <AlipayRecharge
      :isVisible="isVisible"
      @emitCheckRecharge="emitCheckRecharge"
      @emitRechargeDialogClose="emitRechargeDialogClose"
    />
    <HuifuRecharge
      :isVisible="isHuifuVisible"
      @emitCheckRecharge="emitCheckHuifuRecharge"
      @emitRechargeDialogClose="emitCheckHuifuRecharge"
    />
    <AlipayRefund
      :isVisible="refundVisible"
      @emitCheckRecharge="emitCheckRefund"
      @emitRefundDialogClose="emitRefundDialogClose"
    />

    <FaqiRefund
      :dialog-data="initRefundDialog"
      :deliver-data="deliverData"
      @click="initRefund"
    />

    <awardDialog ref="award-dialog" />
  </div>
</template>
<script>
import price from "../../../public/img/price.png";
import recharge from "../../../public/img/recharge.png";
import taxation from "../../../public/img/taxation.png";
import user from "../../../public/img/user.png";
import UploadFile from "@/components/UploadFile";
import NoticeDialog from "@/components/NoticeDialog";
import HomeDatePicker from "@/components/HomeDatePicker";
import AlipayRecharge from "@/components/AlipayRecharge";
import HuifuRecharge from "@/components/HuifuRecharge";
import AlipayRefund from "@/components/AlipayRefund";
import FaqiRefund from "@/components/FaqiRefund.vue";
import LookRefund from "@/components/LookRefund.vue";
import LookLiushui from "@/components/LookLiushui.vue";
import awardDialog from "./components/award-dialog.vue";
import countImportTaxBasis from "./components/countImportTaxBasis.vue";
import { mapState } from "vuex";
import { huifuList } from "@/utils/ylBankList";  
export default {
  components: {
    UploadFile,
    NoticeDialog,
    HomeDatePicker,
    AlipayRecharge,
    HuifuRecharge,
    AlipayRefund,
    FaqiRefund,
    LookRefund,
    LookLiushui,
    awardDialog,
    countImportTaxBasis
  },
  data() {
    return {
      preTaxAmount:0,
      isLaowuCompany:false,
      ISAuxiliary:false, //物流辅助相关公司
      ISLingxin: false, //领薪
      isHuifu:false, // 汇付
      ISwssft: false, //网商
      initRefundDialog: {
        visible: false,
        width: "55%",
        loading: false,
        modal: true,
        confirmText: "发起退款",
        title: "发起退款",
      },
      deliverData: {},
      refundVisible: false,
      isVisible: false,
      isHuifuVisible: false,
      htmlData: "",
      dialogVisible: false,
      pages: [],
      title: "合同",
      dialogData: {
        visible: true,
        title: "客户管家系统升级公告",
        width: "45%",
        loading: true,
        modal: false,
      },
      rules: {},
      formData: {
        file_url: "",
        status: 0,
      },
      list: [
        {
          props:'account_blance',
          title: "账户余额",
          value: "0.00",
          imgUrl: user,
        },
        {
          props:'send_money',
          title: "下发金额",
          value: "0.00",
          icon: "警告",
          imgUrl: price,
        },
        {
          props:'tax_money',
          title: "服务费",
          value: "0.00",
          imgUrl: taxation,
        },
        {
          props:"recharge_money",
          title: "充值金额",
          value: "0.00",
          imgUrl: recharge,
        },
        {
          props:'refundMoney',
          title: "退款金额",
          value: "0.00",
          imgUrl: price,
        },
        {
          props:"refundFree",
          title: "退款服务费",
          value: "0.00",
          imgUrl: recharge,
        },
        {
          props:'now_tax_money',
          title: "已缴纳个税",
          value: "0.00",
          imgUrl: price,
        },
		{
		width:'350px',
		props:'added_tax_money',
		title: "预扣增值税和附加税",
		value: "0.00",
		imgUrl: price,
		},
      ],
      inputPrice: "",
      rechargePrice: "0.00",
      servicePrice: "0.00",
      taxratePrice: "0.00",
      taxrate: "",
      rateType: "",
      realTaxRate: 0,
      accountName: "",
      paymentAccount: "",
      accountBank: "",
      bankOfDeposit: "",
      id: "",
      localStroageId: "",
      searchCondition: {},
      companyId: "",
      is_hidden_rate:false,
    };
  },
  watch: {
    id(val) {
      if (this.pages.includes("index")) {
        if (val != this.localStroageId) {
          setTimeout(() => {
            this.dialogVisible = true;
          }, 500);
        } else {
          this.dialogVisible = false;
        }
      } else {
        this.dialogVisible = false;
      }
    },
  },
  methods: {
    changeInputPrice(){
      this.preTaxAmount = 0
    },
    // 上传文件成功回调
    async handTaxUploadFile({tableData }) {
      console.log(tableData,88888)
      let existNaN = false
      tableData.map(item=>{
        // 处理下发类型
        item.idcard = item.id_number
        if(item.money_type_name == '税前'){
            item.money_type = 1
        }else if(item.money_type_name == '税后'){
            item.money_type = 2
        }
         existNaN = isNaN(item.money)
         if(Number(item.money)<0||Number(item.money)==0){
           flag = true
         }
      })
      if(existNaN){
          this.$message.error('下发金额存在非数字')
          return false
      }
       
      let data = await this.$api.getHomeTaxBasisMoney({
          batch_data:tableData
      })
      this.preTaxAmount = data;
      this.inputPrice = data
      this.calculationPrice()
      console.log(data)
    },
    // 是否是劳务公司
    async getIsLaoWu(){
      let settlementList = await this.$api.getUserSettlement({
        company_id:JSON.parse(localStorage.getItem('nowCompany')).id
      })
      // console.log(settlementList)
      let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
      let newSettlementList = Object.assign(settlementList, [])
      
      newSettlementList.map(item=>{
        if(item.id == companyIds){
          if(item.is_labor_dispatch != 0){
            this.isLaowuCompany = true
          }
        }
      })
      
      console.log(this.isLaowuCompany,'返回标识')
      if(this.isLaowuCompany){
          this.list.push(
            {
              props:"labor_dispatch_money",
              title: "税费",
              value: "0.00",
              imgUrl: taxation,
            }
          )
      }
      this.getInfo();
    },
    initRefund() {
      this.initRefundDialog.visible = true;
      this.deliverData = {
        switchInfo: this.$store.state.switchInfo,
        userPhone: JSON.parse(localStorage.getItem("user_info")).mobile,
        realTaxRate: this.realTaxRate,
        rateType: this.rateType,
      };
    },
    //  解冻
    alipayThaw() {
      this.refundVisible = true;
    },
    //企业支付宝充值
    alipayRecharge() {
      this.isVisible = true;
    },
    emitRechargeDialogClose(val) {
      this.isVisible = val;
    },
    emitCheckRecharge(val) {
      this.isVisible = val;
    },
    emitRefundDialogClose(val) {
      console.log(val);
      this.refundVisible = val;
    },
    emitCheckRefund(val) {
      console.log(val);
      this.refundVisible = val;
    },
    huifuRecharge() {
      this.isHuifuVisible = true;
    },
    emitCheckHuifuRecharge(val) {
      this.isHuifuVisible = val;
    },
    know(value) {
      if (value) {
        this.$storage.set("accountment_id", this.id);
      }
      this.dialogVisible = false;
    },
    handleClose(value) {
      if (value) {
        this.$storage.set("accountment_id", this.id);
      }
      this.dialogVisible = false;
    },
    async calculationPrice() {
      this.rechargePrice = this.mxServicePrice(
        this.inputPrice,
        this.realTaxRate ? this.realTaxRate : this.taxrate,
        this.rateType
      ).resMoney;
      this.rechargePrice = this.rechargePrice.toFixed(2);
      if (Number(this.rateType) == 1) {
        this.servicePrice = (this.rechargePrice - this.inputPrice).toFixed(2);
      } else {
        this.servicePrice = (this.inputPrice - this.rechargePrice).toFixed(2);
      }
    },
    async getInfo() {
      let searchCondition = this.handleSearchCondition();
      searchCondition.ename = this.$config.domain.ename;
      let data = await this.$api.getPrice(searchCondition);
      //网商/微信通道
      this.ISwssft =
        data.account.trade_bank_type == "wssft" ||
        data.account.trade_bank_type == "wechat";
      // console.log(data.account.trade_bank_type)

      console.log(this.ISwssft,'是否是网商通道')
      this.accountName = data.account.trade_channel_account;
      this.paymentAccount = data.account.trade_account;
      this.accountBank = data.account.bankOfDeposit;
      this.bankOfDeposit = data.account.trade_bank;
      this.taxrate = data.account.company_rate;
      if (data.account.rate_type) {
        this.rateType = Number(data.account.rate_type);
      } else {
        this.rateType = 1;
      }
      this.realTaxRate = data.account.tax_rate;
      this.id = data.announcement ? data.announcement.id : 0;
      this.companyId = data.account.id;
      this.$store.commit("changeSwitchInfo", {
        key: "nowCompanyCanUse",
        value: data.dashboard.account_blance,
      });
      this.$store.commit("changeSwitchInfo", {
        key: "nowCompanyTax",
        value: data.account.tax_rate,
      });
      this.$storage.set("dashboard", data.dashboard);
      let nowCompanyInfo = {
        id: data.account.id,
        name: data.account.name,
        trade_uid: data.account.trade_uid,
        trade_bank_type: data.account.trade_bank_type,
      };
      localStorage.setItem("nowCompany", JSON.stringify(nowCompanyInfo));
      //不需要展示账户白名单
      let shuiyoudiList = [
        "sycard",
        "syalipay",
        "sywechat",
        "lingxin",
        "lingxincard",
        "lingxinalipay",
        "lingxinwechat",
      ];
      this.ISLingxin = shuiyoudiList.includes(nowCompanyInfo.trade_bank_type);
      this.isHuifu = huifuList.includes(nowCompanyInfo.trade_bank_type);
      console.log("trade_bank_type   " + nowCompanyInfo.trade_bank_type);
      this.$store.commit("changeSwitchInfo", {
        key: "nowCompany",
        value: nowCompanyInfo,
      });

      // this.list.forEach((item, index) => {
      //   if (index != this.list.length - 1 && index != this.list.length - 2) {
      //     item.value = Object.values(data.dashboard)[index];
      //   } else {
      //     if (index == this.list.length - 1) {
      //       item.value = data.refundFree;
      //     } else {
      //       item.value = data.refundMoney;
      //     }
      //   }
      // });
      this.list.forEach(item=>{
        for(let key in data.dashboard){
          if(item.props == key){
            item.value = data.dashboard[key]
          }
        }

        if(item.props == 'refundMoney'){
          item.value = data.refundMoney
        }else if(item.props == 'refundFree'){
          item.value = data.refundFree
        }
      })
      
      let companyIds = this.$config.domain?.settlmentlCustom?.companyIds || [];
      companyIds.forEach((item) => {
        if (this.companyId == item) {
          if (
            this.$config.domain.settlmentlCustom.originName.includes(
              this.accountName
            )
          ) {
            this.paymentAccount = this.$config.domain.settlmentlCustom.paymentAccount;
            this.bankOfDeposit = this.$config.domain.settlmentlCustom.bankOfDeposit;
            this.accountName = this.$config.domain.settlmentlCustom.currentName;
            this.taxrate = this.$config.domain.settlmentlCustom.taxRate;
            this.list.forEach((i, index) => {
              i.value = Object.values(data.dashboard)[index];
              if (i.title == "服务费" || i.title == "充值金额") {
                i.value = this.$config.domain.settlmentlCustom.placeholder;
              }
            });
          }
        }
      });
      // console.log('htmlData'+data)
      this.htmlData = data?.announcement?.content || "";
      this.pages = data?.announcement?.pages ? [data.announcement.pages] : [];
      if (this.pages.includes("index")) {
        this.localStroageId = this.$storage.get("accountment_id");
        if (this.localStroageId) {
          this.dialogVisible = false;
        } else {
          setTimeout(() => {
            this.dialogVisible = true;
          }, 500);
        }
      } else {
        this.dialogVisible = false;
      }
      // 以下公司不显示服务费率等信息
      let companyArr = ['610836124806639616','610838044971593728','610838731138756608']
      const hidden_rate_arr=['512632405283311616','261476808646303744']
      console.log(JSON.parse(localStorage.getItem('user_info')).company_id,'返回结果')
      let tar_company = JSON.parse(localStorage.getItem('user_info')).company_id
      //隐藏公司的服务费率信息
      if(hidden_rate_arr.includes(tar_company)){
        this.is_hidden_rate = true
      }
      if(companyArr.includes(tar_company)){
        this.ISAuxiliary = true
      }else{
        this.ISAuxiliary = false
      }
    },

    // 处理模态框，关闭事件
    dialogClose() {
      this.initData();
    },
    // 初始化数据
    initData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.dialogData.visible = false;
        this.dialogData.loading = true;
        this.isInherit = true;
        this.namePrefix = "";
        this.formData = {
          display_name: "",
        };
      });
    },
    //导入跳转
    importExcel() {},
    // 删除文件回调
    handleRemoveFile() {
      console.log("->删除成功....");
    },
    // 上传文件成功回调
    handUploadFile({ url, filename }) {
      console.log("->上传成功....", url, filename);
      this.formData.file_url = url;
      this.formSubmit();
    },
    async formSubmit() {
      try {
        let id = await this.$api.saveContract(this.formData);
        if (id) {
          this.$notify.success("保存成功！");
          this.mxInitUserInfo();
          this.mxRedirect("/");
        }
      } catch (err) {
        console.log("err is ->", err);
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
      this.getInfo();
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.time_value.length) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    async getPaper() {
      let res = await this.$api.getQuesStatus();
      this.$nextTick(()=>{
        if(res) return;
        this.$refs['award-dialog'].openDialog()
      })
    },
  },
  mounted() {
    setTimeout(()=>{
      this.getIsLaoWu()
    },600)
    // this.getPaper();
  },
  beforeCreate() {
    if (this.$storage.get("is_yichen")) {
      this.$router.replace("/yicheng");
    }
  },
  created() {
    this.$store.commit(
      "changephone",
      JSON.parse(localStorage.getItem("user_info"))?.mobile
    );
    console.log("this.$store.state.userPhone", this.$store.state.userPhone);
  },
  computed: {
    ...mapState({
      userPermissions:(state) => state.userPermissions,
      isAlipay: (state) => state.switchInfo.isAlipay,
      nowCompanyCanUse: (state) => state.switchInfo.nowCompanyCanUse,
    }),
    isRootRoutePath: function() {
      return this.$route.path == "/";
    },
  },
};
</script>
<style lang="stylus" scoped>
.price-right-wrap{
	width 100%
}
.top
	display flex
	justify-content space-between
#right-btn
	text-align right
	display Inline-block
.first-price-span
	color #FBAB5F
	text-align center
	font-size 60px
.first-price-item
	font-size 40px
	margin-top 80px
	margin-bottom 50px
	color #333
	&.hidden
		margin-top 0px
		margin-bottom 0px
		visibility: hidden
.price-item-wrapper
	width 70%
	margin 0 auto
.price-left, .price-right
	border 1px solid rgba(223, 223, 223, 1)
	width 100%
	display flex
	flex-direction row
	justify-content center
.price-left
	border-right none
.recharge-wrapper
	border 1px solid rgba(223, 223, 223, 1)
	padding-left 40px
	display flex
	align-items center
	margin-top 40px
	height 80px
.recharge-wrapper
	border-bottom none
.recharge
	height 40px
	border-left 7px solid #42B1FE
	line-height 40px
	font-size 25px
	color rgba(66, 177, 254, 1)
	padding-left 20px
.price-wrapper
	display flex
	flex-direction row
	justify-content space-around
	width 100%
	margin 0 auto
	height 450px
	margin-top -20px
.calculation-price
	border-radius 10px
	width 50%
.calculation
	display flex
	flex-direction row
	justify-content flex-end
	padding-right 40px
	margin 10px 0
.calculate
	width 80px
	text-align center
	font-size 18px
	height 40px
	line-height 40px
	background-color #ff9b21
	background-image linear-gradient(to right, #ff9b21, #ff8030)
	border-radius 5px
	margin-left 5px
	color #fff
.calculate:hover
	cursor pointer
.price-item
	font-size 20px
	padding 5px
	color #333
	&.pd
		margin-top: 180px
.zeroRate
	margin-top 180px
.price-span
	color #67757c
.el-container
	background #f0f2f5
.el-aside
	min-height 100vh
	box-shadow 2px 0 6px rgba(0, 21, 41, 0.35)
	position relative
	width auto !important
	z-index 10
	transitionall 0.3s
	background #2c343f
.el-header
	height 64px !important
	padding 0px
	width 100%
.el-main
	padding 0px
	margin 24px
	overflow inherit
	flexnone @css !important
	min-height 720px
.main-page-content
	border-radius 5px
	background #ffffff
	padding 24px
.el-footer
	height auto !important
.el-row
	margin-bottom 20px
	&:last-child
		margin-bottom 0
.el-col
	border-radius 4px
.bg-purple-dark
	background #99a9bf
.bg-purple
	display flex
	flex-direction row
	justify-content space-between
	align-items center
	padding 20px 30px
	font-size 20px
	background #F7F8FA
.info-title, .info-price
	padding 5px
.info-title
	color #333
.info-img
	width 55px
	height 55px
.bg-purple-light
	background #e5e9f2
.grid-content
	border-radius 4px
	min-height 36px
	margin-bottom 20px
.row-bg
	padding 10px 0
	background-color #f9fafc
.page-header
	background #fff
	padding 16px 32px 0 32px
	border-bottom 1px solid #e8e8e8
.page-content
	margin 0 auto
.main-page-content
	min-height 600px
.agree-header
	display flex
	flex-direction row
	justify-content center
	color rgba(255, 149, 2, 1)
	margin-top 20px
	font-size 100px
.agree-title
	width 978px
	background-color rgba(255, 255, 255, 0)
	color rgba(166, 23, 23, 1)
	font-size 18px
	text-align center
	font-family Roboto
	margin 0 auto
.go-to
	position absolute
	bottom 100px
	right 100px
.warn-title
	width 1143px
	height 50px
	line-height 50px
	margin 0 auto
	border-radius 5px 5px 5px 5px
	background-color rgba(82, 80, 80, 1)
	color #fff
	font-size 20px
	text-align center
	font-family Roboto
	border 1px solid rgba(187, 187, 187, 1)
.table-header
	margin-bottom 12px
.contact-upload
	padding-top 50px
	width 980px
	margin 0 auto
.mod-index
	border-radius 5px
	background #fff
	padding 24px
	min-height 800px
	line-height 1.5
	p
		margin 0
	h3
		margin-block-start 0
		margin-block-end 0.5em
	.xm-gt img
		height 240px
		margin-left -16px
	.jx-zz img
		height 400px
		margin-top 24px
		margin-right 24px
.el-container
	background #f0f2f5
.el-aside
	min-height 100vh
	box-shadow 2px 0 6px rgba(0, 21, 41, 0.35)
	position relative
	width auto !important
	z-index 10
	transitionall 0.3s
	background #2c343f
.el-header
	height 64px !important
	padding 0px
	width 100%
.el-main
	padding 0px
	margin 24px
	overflow inherit
	flexnone @css { !important }
	min-height 720px
.main-page-content
	border-radius 5px
	background #ffffff
	padding 24px
.el-footer
	height auto !important
.el-row
	margin-bottom 20px
	&:last-child
		margin-bottom 0
.el-col
	border-radius 4px
.bg-purple-dark
	background #99a9bf
.bg-purple
	display flex
	flex-direction row
	justify-content space-between
	align-items center
	padding 20px 30px
	font-size 20px
	background #F7F8FA
.info-title, .info-price
	padding 5px
.info-title
	color #333
	display flex
	align-items center
.info-img
	width 55px
	height 55px
.bg-purple-light
	background #e5e9f2
.grid-content
	border-radius 4px
	min-height 36px
.row-bg
	padding 10px 0
	background-color #f9fafc
.check-box
	padding 10px 0
.upgrade-title/deep/.el-dialog__title
	display flex
	justify-content center
.dialog-footer
	display flex
	justify-content center
/deep/.info-title .el-icon-warning
	font-size 25px
	color #e6a23c
	margin-left 10px
.el-col-2
	width 5%
</style>
